<div class="app {{ appWrapperClass }}">
  <header>
    <app-header-bar class="header-bar"></app-header-bar>
    <app-side-bar
      class="side-bar-mobile"
      *ngIf="globals.isMobile"
      [isMobile]="true"
    ></app-side-bar>
  </header>
  <div class="last-login-time mobile" *ngIf="globals.model.LastLoginTime">
    Last login: {{ globals.model.LastLoginTime }}
  </div>
  <main class="container" [class.container-mobile]="globals.isMobile">
    <div class="row">
      <app-side-bar
        class="side-bar-desktop col-lg-3"
        *ngIf="!globals.isMobile"
        [isMobile]="false"
      ></app-side-bar>
      <div
        class="page-content"
        [class.col-lg]="globals.isMobile || !hasSideBar"
        [class.col-lg-9]="!globals.isMobile && hasSideBar"
      >
        <router-outlet
          (activate)="onRouterOutletActivate($event)"
        ></router-outlet>
      </div>
    </div>
  </main>
</div>

<app-loading *ngIf="isLoading" class="loader"></app-loading>

<div class="debug-tools">
  <div class="debug-tools__content">
    <h3>Demo notes</h3>

    <div>
      <div>Is Account Locked</div>
      <div class="row">
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="true"
              name="isAccountLocked"
              [checked]="globals.mockedIsAccountLocked === true"
              (click)="mockIsAccountLocked(true)"
            />
            Yes
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="false"
              name="isAccountLocked"
              [checked]="globals.mockedIsAccountLocked === false"
              (click)="mockIsAccountLocked(false)"
            />
            No
          </label>
        </div>
      </div>
    </div>

    <div>
      <div>Is First Time Login</div>
      <div class="row">
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="true"
              name="isFirstTimeLogin"
              [checked]="globals.mockedIsFirstTimeLogin === true"
              (click)="mockIsFirstTimeLogin(true)"
            />
            Yes
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="false"
              name="isFirstTimeLogin"
              [checked]="globals.mockedIsFirstTimeLogin === false"
              (click)="mockIsFirstTimeLogin(false)"
            />
            No
          </label>
        </div>
      </div>
    </div>

    <div>
      <div>Declared risk level</div>
      <div class="row">
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="null"
              name="declaredRiskProfile"
              [checked]="globals.mockedDeclaredRisk === null"
              (click)="mockDeclaredRisk(null)"
            />
            No override
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              value="Conservative"
              name="declaredRiskProfile"
              [checked]="globals.mockedDeclaredRisk === riskLevel.CONSERVATIVE"
              (click)="mockDeclaredRisk(riskLevel.CONSERVATIVE)"
            />
            Conservative
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              value="Moderate"
              name="declaredRiskProfile"
              [checked]="globals.mockedDeclaredRisk === riskLevel.MODERATE"
              (click)="mockDeclaredRisk(riskLevel.MODERATE)"
            />
            Moderate
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              value="Aggressive"
              name="declaredRiskProfile"
              [checked]="globals.mockedDeclaredRisk === riskLevel.AGGRESSIVE"
              (click)="mockDeclaredRisk(riskLevel.AGGRESSIVE)"
            />
            Aggressive
          </label>
        </div>
      </div>
    </div>

    <div>
      <div>Assessed risk level</div>
      <div class="row">
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="null"
              name="assessedRiskProfile"
              [checked]="globals.mockedAssessedRisk === null"
              (click)="mockAssessedRisk(null)"
            />
            No override
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              value="Conservative"
              name="assessedRiskProfile"
              [checked]="globals.mockedAssessedRisk === riskLevel.CONSERVATIVE"
              (click)="mockAssessedRisk(riskLevel.CONSERVATIVE)"
            />
            Conservative
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              value="Moderate"
              name="assessedRiskProfile"
              [checked]="globals.mockedAssessedRisk === riskLevel.MODERATE"
              (click)="mockAssessedRisk(riskLevel.MODERATE)"
            />
            Moderate
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              value="Aggressive"
              name="assessedRiskProfile"
              [checked]="globals.mockedAssessedRisk === riskLevel.AGGRESSIVE"
              (click)="mockAssessedRisk(riskLevel.AGGRESSIVE)"
            />
            Aggressive
          </label>
        </div>
      </div>
    </div>

    <div>
      <div>Accept Assessed Risk Profile</div>
      <div style="font-size: 12px">
        This simulates to redirect user to Recommended or Non-recommended
        product screen.
      </div>
      <div class="row">
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="true"
              name="isAcceptAssessedRiskProfile"
              [checked]="globals.mockIsAcceptAssessedRiskProfile === true"
              (click)="mockAcceptAssessedRiskProfile(true)"
            />
            Yes
          </label>
        </div>
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="false"
              name="isAcceptAssessedRiskProfile"
              [checked]="globals.mockIsAcceptAssessedRiskProfile === false"
              (click)="mockAcceptAssessedRiskProfile(false)"
            />
            No
          </label>
        </div>
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="null"
              name="isAcceptAssessedRiskProfile"
              [checked]="globals.mockIsAcceptAssessedRiskProfile === null"
              (click)="mockAcceptAssessedRiskProfile(null)"
            />
            Null
          </label>
        </div>
      </div>
    </div>

    <div>
      <div>Accept Recommended Products</div>
      <div style="font-size: 12px">
        This simulates to show or hide the Table A products section in the
        non-recommended products screen.
      </div>
      <div class="row">
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="true"
              name="isAcceptRecommendedProducts"
              [checked]="globals.mockIsAcceptRecommendedProducts === true"
              (click)="mockAcceptRecommendedProducts(true)"
            />
            Yes
          </label>
        </div>
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="false"
              name="isAcceptRecommendedProducts"
              [checked]="globals.mockIsAcceptRecommendedProducts === false"
              (click)="mockAcceptRecommendedProducts(false)"
            />
            No
          </label>
        </div>
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="null"
              name="isAcceptRecommendedProducts"
              [checked]="globals.mockIsAcceptRecommendedProducts === null"
              (click)="mockAcceptRecommendedProducts(null)"
            />
            Null
          </label>
        </div>
      </div>
    </div>

    <div>
      <div>Purchase Table B Products</div>
      <div style="font-size: 12px">
        This simulates to show/hide Non-recommended product screen.
      </div>
      <div class="row">
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="true"
              name="isPurchaseTableBProducts"
              [checked]="globals.mockIsPurchaseTableBProducts === true"
              (click)="mockIsPurchaseTableBProducts(true)"
            />
            Yes
          </label>
        </div>
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="false"
              name="isPurchaseTableBProducts"
              [checked]="globals.mockIsPurchaseTableBProducts === false"
              (click)="mockIsPurchaseTableBProducts(false)"
            />
            No
          </label>
        </div>
        <div class="col-sm-4">
          <label>
            <input
              type="radio"
              [value]="null"
              name="isPurchaseTableBProducts"
              [checked]="globals.mockIsPurchaseTableBProducts === null"
              (click)="mockIsPurchaseTableBProducts(null)"
            />
            Null
          </label>
        </div>
      </div>
    </div>

    <div>
      <div>Simulate server behaviour</div>
      <div class="row">
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="true"
              name="simulateServerBehaviour"
              [checked]="globals.simulateServerBehaviour === true"
              (click)="mockSimulateServerBehaviour(true)"
            />
            Yes
          </label>
        </div>
        <div class="col-sm-6">
          <label>
            <input
              type="radio"
              [value]="false"
              name="simulateServerBehaviour"
              [checked]="globals.simulateServerBehaviour === false"
              (click)="mockSimulateServerBehaviour(false)"
            />
            No
          </label>
        </div>
      </div>
    </div>

    <button (click)="logDebugData()">Log data</button>
    <button *ngIf="globals.isDebug" (click)="toggleDebug()">Debug on</button>
    <button *ngIf="!globals.isDebug" (click)="toggleDebug()">Debug off</button>
    <app-secondary-button
      *ngIf="isFillFormAvailable"
      [outline]="true"
      (click)="fillFormWithMockData()"
      >Fill form with mock data</app-secondary-button
    >

    <div class="debug-tools__trigger">: )</div>
  </div>
</div>
